const VARIANTS = {
  'contact-info': '--contact-info',
  stretch: '--stretch', // stretches to edges of parent container (no padding, width 100%)
};

export default VARIANTS;
